import styled from "styled-components";
import "maplibre-gl/dist/maplibre-gl.css";
import { Skeleton } from "@mui/material";

const Container = styled.div`
  position: relative;
  width: 100%;
  height: calc(100vh - 68px);
`;

const RectangleSkeleton = styled(Skeleton)({
  height: "24px",
  "&.MuiSkeleton-root": {
    variant: "rectangle",
    backgroundColor: (props) => props.theme.color.background.tertiary,
  },
});

const Map = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
`;

const Spacer = styled.div`
  width: 100%;
  border-top: 1px solid white;
  opacity: 12%;
  margin-top: 26px;
`;

export { Container, RectangleSkeleton, Map, Spacer };
